import { render, staticRenderFns } from "./OrderBatchDetails.vue?vue&type=template&id=a044c438"
import script from "./OrderBatchDetails.vue?vue&type=script&lang=js"
export * from "./OrderBatchDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports